import Vue from 'vue'
import Router from 'vue-router'
import routeTable from "./routes"

Vue.use(Router)
const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};


export default new Router({
    routes: routeTable,
})


// WEBPACK FOOTER //
// ./src/router/index.js